import React from 'react';

const COUNTRY_CODES = [
  { code: '+262', label: 'Réunion/Mayotte', flag: '🇷🇪' },
  { code: '+33', label: 'France', flag: '🇫🇷' },
//   { code: '+590', label: 'Guadeloupe', flag: '🇬🇵' },
//   { code: '+594', label: 'Guyane', flag: '🇬🇫' },
//   { code: '+596', label: 'Martinique', flag: '🇲🇶' },
];

// Formater le numéro de téléphone (espaces tous les 2 chiffres)
const formatPhoneNumber = (value) => {
  if (!value) return '';
  // Retirer tout sauf les chiffres
  const digits = value.replace(/\D/g, '');
  // Formater avec des espaces tous les 2 chiffres
  // return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
  return digits.trim();
};

// Extraire l'indicatif et le numéro d'une valeur complète
const parsePhoneValue = (fullValue) => {
  if (!fullValue) return { countryCode: '+262', number: '' };
  
  // Chercher si la valeur commence par un indicatif connu
  for (const country of COUNTRY_CODES) {
    if (fullValue.startsWith(country.code)) {
      return {
        countryCode: country.code,
        number: fullValue.substring(country.code.length).trim()
      };
    }
  }
  
  // Si pas d'indicatif trouvé, retourner la valeur telle quelle avec indicatif par défaut
  return { countryCode: '+262', number: fullValue };
};

export default function PhoneInput({ 
  value, 
  onChange, 
  name, 
  id, 
  placeholder = '',
  required = false,
  className = '',
  error = false 
}) {
  const { countryCode, number } = parsePhoneValue(value);

  const handleCountryChange = (e) => {
    const newCountryCode = e.target.value;
    // Retirer les espaces du numéro pour stocker le format complet sans espaces
    const cleanNumber = number.replace(/\s/g, '');
    onChange(`${newCountryCode}${cleanNumber}`);
  };

  const handleNumberChange = (e) => {
    const rawValue = e.target.value;
    // Retirer tout sauf les chiffres pour le stockage
    const cleanNumber = rawValue.replace(/\D/g, '');
    // Envoyer le numéro complet avec indicatif, sans espaces (ex: +262692781800)
    onChange(`${countryCode}${cleanNumber}`);
  };

  const baseInputClass = "shadow-sm focus:ring-honey-500 focus:border-honey-500 block w-full sm:text-sm border-gray-300 rounded-md p-2";
  const errorClass = error ? "border-red-300 focus:ring-red-500 focus:border-red-500" : "";

  return (
    <div className="flex gap-2">
      {/* Sélecteur d'indicatif */}
      <select
        value={countryCode}
        onChange={handleCountryChange}
        className={`${baseInputClass} ${errorClass} w-24 flex-shrink-0`}
        aria-label="Indicatif pays"
      >
        {COUNTRY_CODES.map((country) => (
          <option key={country.code} value={country.code}>
            {country.flag} {country.code}
          </option>
        ))}
      </select>
      
      {/* Champ numéro */}
      <input
        type="tel"
        name={name}
        id={id}
        value={formatPhoneNumber(number)}
        onChange={handleNumberChange}
        placeholder={placeholder}
        required={required}
        className={`${baseInputClass} ${errorClass} ${className} flex-1`}
      />
    </div>
  );
}

// Export des utilitaires pour usage externe
export { formatPhoneNumber, parsePhoneValue, COUNTRY_CODES };
